// 261030 — giao diện luồng 4 bước KHÔNG hiện tiền. Số tiền vẫn nằm trong estimate / estimateHash / requestId gửi BE (an toàn tiền ở BE); FE chỉ hiện số lượng
// (ảnh, prompt, video, giây). Chữ do BE dựng (nhãn nút, lời dặn) có thể kèm «≈ $x» ⇒ đi qua `stripMoneyOf` trước khi hiện.

/** Một cụm tiền: «≈ $1,05», «~$0,01–0,03», «tối đa ≈ $13,56», «US$2», «3 USD», kèm dấu phẩy/gạch đứng trước. */
const MONEY_RE = /\s*[,;·—-]?\s*(?:(?:tối đa|ước|khoảng|chỉ)\s+)?[≈~]?\s*(?:US\$|\$)\s?\d+(?:[.,]\d+)*(?:\s*[–-]\s*\d+(?:[.,]\d+)*)?|\s*[,;·—-]?\s*[≈~]?\s*\d+(?:[.,]\d+)*\s*USD\b/gi;

/** Bỏ mọi cụm tiền khỏi một câu hiển thị; dọn ngoặc rỗng / khoảng trắng thừa. Không có tiền ⇒ trả đúng chuỗi cũ. */
export function stripMoneyOf(text: string): string;
export function stripMoneyOf(text: string | null | undefined): string | null;
export function stripMoneyOf(text: string | null | undefined): string | null {
  if (text == null) return null;
  if (!/\$|USD/i.test(text)) return text;
  return text.replace(MONEY_RE, '').replace(/\(\s*\)/g, '').replace(/\s{2,}/g, ' ').replace(/\s+([.,;:)])/g, '$1').trim();
}

/** Câu còn dấu hiệu tiền ($ trước số, USD)? Dùng cho test quét. */
export const hasMoneyText = (text: string): boolean => /(?:US)?\$\s?\d|\bUSD\b/i.test(text);
